import {generateAsyncActionCreators} from '../core/reduxUtils'

const getProductActionCreators = generateAsyncActionCreators(
  'GET_PRODUCT',
  (sku, params, isProductId) => ({
    sku,
    params,
    isProductId
  })
)

const getBasicProductActionCreators = generateAsyncActionCreators(
  'GET_BASIC_PRODUCT',
  (sku, params, isProductId) => ({
    sku,
    params,
    isProductId
  })
)

const getSplitProductVariantsActionCreators = generateAsyncActionCreators(
  'GET_SPLIT_PRODUCT_VARIANTS',
  (sku, params) => ({
    sku,
    params,
  })
);

const getProductReturnPolicyActionCreators = generateAsyncActionCreators(
  'GET_PRODUCT_RETURN_POLICY',
  (productSku, params) => ({
    productSku,
    params,
  })
);

const getSizeChartActionCreators = generateAsyncActionCreators(
  'GET_SIZE_CHART',
  (params) => ({
    params,
  })
);

const getCardAndInstallmentActionCreators = generateAsyncActionCreators(
  'GET_CARD_AND_INSTALLMENT',
  (params) => ({
    params,
  })
);

const getDesktopTabsActionCreators = generateAsyncActionCreators(
  'GET_DESKTOP_TABS',
  (index) => ({
    index,
  })
);

const setAdultProductActionCreators = generateAsyncActionCreators(
  'SET_PRODUCT_ADULT',
  (payload) => ({
    payload,
  })
);

const setAdultProductCookieActionCreators = generateAsyncActionCreators(
  'SET_PRODUCT_ADULT_COOKIE',
  (payload) => ({
    payload,
  })
);

const setTabsModalVisibleActionCreators = generateAsyncActionCreators(
  'SET_TABS_MODAL_VISIBLE',
  (isVisible, index) => ({
    isVisible,
    index,
  })
);

const getVasActionCreators = generateAsyncActionCreators(
  'GET_VAS',
  (params) => ({
    params,
  })
);

const setAddVasProductActionCreators = generateAsyncActionCreators(
  'SET_ADD_VAS_PRODUCT',
  (sku, params) => ({
    sku,
    params
  })
);

const setLoyaltyInfoActionCreators = generateAsyncActionCreators(
  'SET_LOYALTY_INFO',
  (data) => ({
    data
  })
);

const setRemoveVasProductActionCreators = generateAsyncActionCreators(
  'SET_REMOVE_VAS_PRODUCT',
  (sku) => ({
    sku
  })
);

const setRemoveAllVasProductActionCreators = generateAsyncActionCreators(
  'SET_REMOVE_ALL_VAS_PRODUCT',
  () => ({})
);

const setProductIsLoadingActionCreators = generateAsyncActionCreators(
  'SET_PRODUCT_IS_LOADING',
  (isLoading) => ({
    isLoading
  })
);

const updateProductVariantActionCreators = generateAsyncActionCreators(
  'UPDATE_PRODUCT_VARIANT',
  (variant) => ({
    variant
  })
);

const getCampaignsPdpDashboardActionCreators = generateAsyncActionCreators(
  'GET_CAMPAIGNS_PDP_DASHBOARD',
  (params) => ({
    params
  })
);

const getDueDateActionCreators = generateAsyncActionCreators(
  'GET_DUE_DATE',
  (params) => ({
    params
  })
);

const getDueDateProductsActionCreators = generateAsyncActionCreators(
  'GET_DUE_DATE_PRODUCTS',
  (params) => ({
    params
  })
);

const getProductListingsActionCreators = generateAsyncActionCreators(
  'GET_PRODUCT_LISTINGS',
  (sku, params) => ({
    sku,
    params,
  })
);

const getOtherSellerCouponActionCreators = generateAsyncActionCreators(
  'GET_OTHER_SELLER_COUPON',
  (params) => ({
    params
  })
);

const getOtherSellerCampaignActionCreators = generateAsyncActionCreators(
  'GET_OTHER_SELLER_CAMPAIGN',
  (params) => ({
    params
  })
);

const getComparedProductsActionCreators = generateAsyncActionCreators(
  'GET_COMPARED_PRODUCTS',
  (params) => ({
    params,
  })
);

const actionCreators = {
  getProduct: {
    ...getProductActionCreators,
  },
  getBasicProduct: {
    ...getBasicProductActionCreators,
  },
  getSplitProductVariants: {
    ...getSplitProductVariantsActionCreators,
  },
  getProductReturnPolicy: {
    ...getProductReturnPolicyActionCreators,
  },
  getSizeChart: {
    ...getSizeChartActionCreators,
  },
  getCardAndInstallment: {
    ...getCardAndInstallmentActionCreators,
  },
  setAdultProduct: {
    ...setAdultProductActionCreators,
  },
  setLoyaltyInfo: {
    ...setLoyaltyInfoActionCreators,
  },
  setAdultProductCookie: {
    ...setAdultProductCookieActionCreators,
  },
  setTabsModalVisible: {
    ...setTabsModalVisibleActionCreators,
  },
  getVas: {
    ...getVasActionCreators,
  },
  setAddVasProduct: {
    ...setAddVasProductActionCreators,
  },
  setRemoveVasProduct: {
    ...setRemoveVasProductActionCreators,
  },
  setRemoveAllVasProduct: {
    ...setRemoveAllVasProductActionCreators,
  },
  setProductIsLoading: {
    ...setProductIsLoadingActionCreators
  },
  updateProductVariant: {
    ...updateProductVariantActionCreators,
  },
  getCampaignsPdpDashboard: {
    ...getCampaignsPdpDashboardActionCreators,
  },
  getProductListings: {
    ...getProductListingsActionCreators,
  },
  getDueDate: {
    ...getDueDateActionCreators,
  },
  getDueDateProducts: {
    ...getDueDateProductsActionCreators,
  },
  setDesktopTabs: {
    ...getDesktopTabsActionCreators
  },
  getOtherSellerCoupon: {
    ...getOtherSellerCouponActionCreators
  },
  getOtherSellerCampaign: {
    ...getOtherSellerCampaignActionCreators
  },
  getComparedProducts: {
    ...getComparedProductsActionCreators
  }
}

export {
  actionCreators,
  getProductActionCreators,
  getSplitProductVariantsActionCreators,
  getProductReturnPolicyActionCreators,
  getSizeChartActionCreators,
  getCardAndInstallmentActionCreators,
  getCampaignsPdpDashboardActionCreators,
  getProductListingsActionCreators,
  getDueDateActionCreators,
  getDueDateProductsActionCreators,
  getDesktopTabsActionCreators,
  getOtherSellerCouponActionCreators,
  getOtherSellerCampaignActionCreators,
  getVasActionCreators,
  getComparedProductsActionCreators,
  getBasicProductActionCreators
}
